import { SpaceProps } from '@wrisk/styled-system'
import React, { FunctionComponent } from 'react'

import { getCurrentQuote } from '../../../domain'
import { usePromotion } from '../../../hooks/covers'
import { TKey } from '../../../infrastructure/internationalisation'
import { useProposal } from '../../product/proposal/ProposalProvider'
import { PromotionBanner } from './PromotionBanner'

const tKey = TKey('components.promotion-banner')

export const RenewalPromotionBanner: FunctionComponent<SpaceProps> = (props) => {
  const { proposal } = useProposal()
  const quote = getCurrentQuote(proposal)
  const promotion = usePromotion(quote)

  return quote.promoCode && promotion ? (
    <PromotionBanner
      tKey={tKey}
      promoCode={quote.promoCode}
      variant='narrow'
      {...props}
    />
  ) : null
}
